import { css } from 'styled-components';
import {
  getTypography, ThemedFunctor, TypographyName,
} from '@doveit/lego';

export const highlights: ThemedFunctor = ({
  theme,
}) => css`
  span {
    ${getTypography(theme, TypographyName.SMALL)}
    display: inline-block;
    line-height: 1;
    border-right: 1px solid ${theme.palettes.neutrals.light};
    padding-right: 0.5rem;
    margin-right: 0.5rem;

    &:last-of-type {
      border-right: 0;
      padding-right: 0;
      margin-right: 0;
    }
  }
`;
